const e = 0, o = 1e4, t = 1, c = 50;
export {
  e as CACHE_EXPIRATION_TIME,
  o as CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  t as DEFAULT_PAGE,
  c as DEFAULT_PAGE_SIZE
};
//# sourceMappingURL=constants.js.map
